export const avatarSizes = {
  medium: 48
} as const;

export type AvatarSize = keyof typeof avatarSizes;
